const UserModelsEnum = Object.freeze({
  User: 'User',
  SUDO: 'SUDO',
  ADMIN: 'ADMIN',
})

export default UserModelsEnum
